import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./store/authSlice";
import urlreducer from "./store/urlSlice";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
const store = configureStore({
  reducer: {
    auth: authReducer,
    url: urlreducer,
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </Provider>
);
